// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as ApiUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as CustomerRepoConfig from "./CustomerRepoConfig.bs.js";

var dummyCustomerOrderResponse = {
    "result": {
      "order": [
    {
        "order_id": "CRN0000000000",
        "order_date": 1680336334890,
        "order_time": 1680336334890,
        "status": "Completed",
        "vehicle": {
            "vehicle_type": "2 Wheeler",
            "registration_number": "AH-00-0-0000"
        },
        "partner": {
            "name": "Test test",
            "mobile": "0000000000"
        }
    },
    {
        "order_id": "CRN0000000000",
        "order_date": 1678889714278,
        "order_time": 1678889714278,
        "status": "completed",
        "vehicle": {
            "vehicle_type": "3 Wheeler",
            "registration_number": "AH-00-0-0000"
        },
        "partner": {
            "name": "test test",
            "mobile": "0000000000"
        }
    },
    {
        "order_id": "CRN0000000000",
        "order_date": 1671964275625,
        "order_time": 1671964275625,
        "status": "completed",
        "vehicle": {
            "vehicle_type": "3 Wheeler",
            "registration_number": "AH-00-0-0000"
        },
        "partner": {
            "name": "test_test",
            "mobile": "0000000000"
        }
    },
    {
        "order_id": "CRN0000000000",
        "order_date": 1671698156136,
        "order_time": 1671698156136,
        "status": "completed",
        "vehicle": {
            "vehicle_type": "3 Wheeler",
            "registration_number": "AH-00-0-0000"
        },
        "partner": {
            "name": "test user",
            "mobile": "0000000000"
        }
    },
    {
        "order_id": "CRN0000000000",
        "order_date": 1671349492013,
        "order_time": 1671349492013,
        "status": "completed",
        "vehicle": {
            "vehicle_type": "Pickup / Dost / Super Ace / 8ft",
            "registration_number": "AH-00-0-0000"
        },
        "partner": {
            "name": "Test",
            "mobile": "0000000000"
        }
    },
    {
        "order_id": "CRN0000000000",
        "order_date": 1671344180329,
        "order_time": 1671344180329,
        "status": "completed",
        "vehicle": {
            "vehicle_type": "Tata 407",
            "registration_number": "AH-00-0-0000"
        },
        "partner": {
            "name": "Test",
            "mobile": "0000000000"
        }
    },
    {
        "order_id": "CRN0000000000",
        "order_date": 1671342641424,
        "order_time": 1671342641424,
        "status": "cancelled",
        "vehicle": {
            "vehicle_type": "Tata 407",
            "registration_number": "AH-00-0-0000"
        },
        "partner": {
            "name": "Test test",
            "mobile": "0000000000"
        }
    },
    {
        "order_id": "CRN0000000000",
        "order_date": 1669875044623,
        "order_time": 1669875044623,
        "status": "completed",
        "vehicle": {
            "vehicle_type": "3 Wheeler",
            "registration_number": "AH-00-0-0000"
        },
        "partner": {
            "name": "test test",
            "mobile": "0000000000"
        }
    },
    {
        "order_id": "CRN0000000000",
        "order_date": 1667297473254,
        "order_time": 1667297473254,
        "status": "completed",
        "vehicle": {
            "vehicle_type": "Tata 407",
            "registration_number": "AH-00-0-0000"
        },
        "partner": {
            "name": "test  test",
            "mobile": "0000000000"
        }
    },
    {
        "order_id": "CRN0000000000",
        "order_date": 1667204348567,
        "order_time": 1667204348567,
        "status": "completed",
        "vehicle": {
            "vehicle_type": "Pickup / Dost / Super Ace / 8ft",
            "registration_number": "AH-00-0-0000"
        },
        "partner": {
            "name": "TEST TEST",
            "mobile": "0000000000"
        }
    }
],
        "last_date_timestamp": null
    }
  };

var dummyTransactionHistoryResponse = {
      "result": {
        "wallet_balance": 23.24,
        "last_date_timestamp": null,
        "transactions": [
    {
        "order_id": null,
        "date": 1669703865980,
        "description": null,
        "is_reverted": false,
        "amount": 0,
        "wallet_balance": 1000,
        "payment_mode": null,
        "instamojo_payment_id": null
    },
    {
        "order_id": null,
        "date": 1669703515527,
        "description": null,
        "is_reverted": false,
        "amount": 0,
        "wallet_balance": 1000,
        "payment_mode": null,
        "instamojo_payment_id": null
    },
    {
        "order_id": null,
        "date": 1668152443175,
        "description": null,
        "is_reverted": false,
        "amount": 0,
        "wallet_balance": 1000,
        "payment_mode": null,
        "instamojo_payment_id": null
    },
    {
        "order_id": null,
        "date": 1668152235759,
        "description": null,
        "is_reverted": false,
        "amount": 0,
        "wallet_balance": 1000,
        "payment_mode": null,
        "instamojo_payment_id": null
    },
    {
        "order_id": null,
        "date": 1668058229339,
        "description": null,
        "is_reverted": false,
        "amount": 0,
        "wallet_balance": 1000,
        "payment_mode": null,
        "instamojo_payment_id": null
    },
    {
        "order_id": null,
        "date": 1668058203826,
        "description": null,
        "is_reverted": false,
        "amount": 0,
        "wallet_balance": 1000,
        "payment_mode": null,
        "instamojo_payment_id": null
    },
    {
        "order_id": null,
        "date": 1663160698793,
        "description": null,
        "is_reverted": false,
        "amount": 50,
        "wallet_balance": 1000,
        "payment_mode": null,
        "instamojo_payment_id": null
    },
    {
        "order_id": null,
        "date": 1663160554931,
        "description": null,
        "is_reverted": false,
        "amount": -100,
        "wallet_balance": 1000,
        "payment_mode": null,
        "instamojo_payment_id": null
    },
    {
        "order_id": null,
        "date": 1663160318678,
        "description": null,
        "is_reverted": false,
        "amount": 100,
        "wallet_balance": 1000,
        "payment_mode": null,
        "instamojo_payment_id": null
    },
    {
        "order_id": null,
        "date": 1663160018335,
        "description": null,
        "is_reverted": false,
        "amount": -100,
        "wallet_balance": 1000,
        "payment_mode": null,
        "instamojo_payment_id": null
    },
    {
        "order_id": "CRN26635130",
        "date": 1660286893176,
        "description": null,
        "is_reverted": false,
        "amount": 1968,
        "wallet_balance": 1000,
        "payment_mode": "CashTransaction",
        "instamojo_payment_id": null
    },
    {
        "order_id": "CRN78353794",
        "date": 1660208679441,
        "description": null,
        "is_reverted": false,
        "amount": 1968,
        "wallet_balance": 1000,
        "payment_mode": "CashTransaction",
        "instamojo_payment_id": null
    },
    {
        "order_id": null,
        "date": 1659535896386,
        "description": null,
        "is_reverted": false,
        "amount": 0,
        "wallet_balance": -10.23,
        "payment_mode": null,
        "instamojo_payment_id": null
    },
    {
        "order_id": null,
        "date": 1659535883467,
        "description": null,
        "is_reverted": false,
        "amount": 0,
        "wallet_balance": 1000,
        "payment_mode": null,
        "instamojo_payment_id": null
    },
    {
        "order_id": null,
        "date": 1659535864774,
        "description": null,
        "is_reverted": false,
        "amount": 0,
        "wallet_balance": 1000,
        "payment_mode": null,
        "instamojo_payment_id": null
    },
    {
        "order_id": null,
        "date": 1659352256074,
        "description": null,
        "is_reverted": false,
        "amount": 0,
        "wallet_balance": 1000.00,
        "payment_mode": "RazorpayPg::Transactions::Transaction",
        "instamojo_payment_id": "pay_K0LbkY8kcRurip"
    },
    {
        "order_id": "CRN81950696",
        "date": 1659026205484,
        "description": null,
        "is_reverted": false,
        "amount": -939,
        "wallet_balance": -1000.9,
        "payment_mode": null,
        "instamojo_payment_id": null
    },
    {
        "order_id": null,
        "date": 1658667866076,
        "description": null,
        "is_reverted": false,
        "amount": 249,
        "wallet_balance": 1000,
        "payment_mode": null,
        "instamojo_payment_id": null
    },
    {
        "order_id": "CRN26691639",
        "date": 1657000843342,
        "description": null,
        "is_reverted": false,
        "amount": 2048,
        "wallet_balance": 1000,
        "payment_mode": "CashTransaction",
        "instamojo_payment_id": null
    },
    {
        "order_id": null,
        "date": 1657000731675,
        "description": null,
        "is_reverted": false,
        "amount": 0,
        "wallet_balance": 1000,
        "payment_mode": null,
        "instamojo_payment_id": null
    },
    {
        "order_id": null,
        "date": 1657000546330,
        "description": null,
        "is_reverted": false,
        "amount": 0,
        "wallet_balance": 1000,
        "payment_mode": null,
        "instamojo_payment_id": null
    },
    {
        "order_id": null,
        "date": 1656999828376,
        "description": null,
        "is_reverted": false,
        "amount": 0,
        "wallet_balance": 1000,
        "payment_mode": null,
        "instamojo_payment_id": null
    },
    {
        "order_id": "CRN38128533",
        "date": 1654968701719,
        "description": null,
        "is_reverted": false,
        "amount": 5306,
        "wallet_balance": 1000,
        "payment_mode": "CashTransaction",
        "instamojo_payment_id": null
    },
    {
        "order_id": "CRN81950696",
        "date": 1654968462043,
        "description": null,
        "is_reverted": false,
        "amount": 939,
        "wallet_balance": 1000,
        "payment_mode": "CashTransaction",
        "instamojo_payment_id": null
    },
    {
        "order_id": "CRN50863219",
        "date": 1653553081815,
        "description": null,
        "is_reverted": false,
        "amount": 650,
        "wallet_balance": 1000,
        "payment_mode": "CashTransaction",
        "instamojo_payment_id": null
    },
    {
        "order_id": "CRN57539414",
        "date": 1653552866333,
        "description": null,
        "is_reverted": false,
        "amount": 450,
        "wallet_balance": 1000,
        "payment_mode": "CashTransaction",
        "instamojo_payment_id": null
    },
    {
        "order_id": "CRN78491796",
        "date": 1653552536881,
        "description": null,
        "is_reverted": false,
        "amount": 450,
        "wallet_balance": 1000,
        "payment_mode": "CashTransaction",
        "instamojo_payment_id": null
    },
    {
        "order_id": "CRN70922554",
        "date": 1653550781512,
        "description": null,
        "is_reverted": false,
        "amount": 467,
        "wallet_balance": 1000,
        "payment_mode": "CashTransaction",
        "instamojo_payment_id": null
    },
    {
        "order_id": "CRN54655961",
        "date": 1653548956261,
        "description": null,
        "is_reverted": false,
        "amount": 6914,
        "wallet_balance": 1000,
        "payment_mode": "CashTransaction",
        "instamojo_payment_id": null
    },
    {
        "order_id": "CRN79633126",
        "date": 1653548630517,
        "description": null,
        "is_reverted": false,
        "amount": 467,
        "wallet_balance": 1000,
        "payment_mode": "CashTransaction",
        "instamojo_payment_id": null
    },
    {
        "order_id": "CRN88829533",
        "date": 1653547844049,
        "description": null,
        "is_reverted": false,
        "amount": 505,
        "wallet_balance": 1000,
        "payment_mode": "CashTransaction",
        "instamojo_payment_id": null
    },
    {
        "order_id": "CRN58940413",
        "date": 1652945064194,
        "description": null,
        "is_reverted": false,
        "amount": 482,
        "wallet_balance": 1000,
        "payment_mode": "CashTransaction",
        "instamojo_payment_id": null
    },
    {
        "order_id": "CRN40656644",
        "date": 1652944670851,
        "description": null,
        "is_reverted": false,
        "amount": 395,
        "wallet_balance": 1000,
        "payment_mode": "CashTransaction",
        "instamojo_payment_id": null
    },
    {
        "order_id": "CRN97749570",
        "date": 1652905718857,
        "description": null,
        "is_reverted": false,
        "amount": 377,
        "wallet_balance": -2000,
        "payment_mode": "CashTransaction",
        "instamojo_payment_id": null
    },
    {
        "order_id": "CRN68810577",
        "date": 1652904733819,
        "description": null,
        "is_reverted": false,
        "amount": 360,
        "wallet_balance": 1000,
        "payment_mode": "CashTransaction",
        "instamojo_payment_id": null
    },
    {
        "order_id": "CRN76636334",
        "date": 1652875622266,
        "description": null,
        "is_reverted": false,
        "amount": 449,
        "wallet_balance": 1000,
        "payment_mode": "CashTransaction",
        "instamojo_payment_id": null
    },
    {
        "order_id": "CRN37084856",
        "date": 1652870140870,
        "description": null,
        "is_reverted": false,
        "amount": 1945,
        "wallet_balance": 1000,
        "payment_mode": "CashTransaction",
        "instamojo_payment_id": null
    },
    {
        "order_id": "CRN30889928",
        "date": 1652786509773,
        "description": null,
        "is_reverted": false,
        "amount": 215,
        "wallet_balance": -1000,
        "payment_mode": "CashTransaction",
        "instamojo_payment_id": null
    },
    {
        "order_id": "CRN57545135",
        "date": 1652782879860,
        "description": null,
        "is_reverted": false,
        "amount": 345,
        "wallet_balance": 1000,
        "payment_mode": "CashTransaction",
        "instamojo_payment_id": null
    },
    {
        "order_id": "CRN65715793",
        "date": 1652782362150,
        "description": null,
        "is_reverted": false,
        "amount": 213,
        "wallet_balance": 1000,
        "payment_mode": "CashTransaction",
        "instamojo_payment_id": null
    }
]
      },
      status: 200
    };

var dummyResponse = {
    "summary": {
        "name": "Madhu Test",
        "is_portergold_active": false,
        "mobile": "500000002",
        "address": null,
        "city": "Dubai",
        "uuid": "028bdb67-2184-471a-bd15-755559b0d0e8",
        "referral": null
    },
    "first_name": {
        "attribute_name": "First Name",
        "attribute_value": "Madhu",
        "is_editable": true,
        "is_verified": false,
        "attribute_note": null
    },
    "last_name": {
        "attribute_name": "Last Name",
        "attribute_value": "Test",
        "is_editable": true,
        "is_verified": false,
        "attribute_note": null
    },
    "caller_type": {
        "attribute_name": "Caller Type",
        "attribute_value": "PRIMARY",
        "is_editable": false,
        "is_verified": false,
        "attribute_note": null
    },
    "mobile": {
        "attribute_name": "Primary Number",
        "attribute_value": "500000002",
        "is_editable": true,
        "is_verified": true,
        "attribute_note": null
    },
    "secondary_mobile": {
        "attribute_name": "Secondary Number",
        "attribute_value": null,
        "is_editable": true,
        "is_verified": false,
        "attribute_note": null
    },
    "company_name": {
        "attribute_name": "Company  Name",
        "attribute_value": "porter",
        "is_editable": true,
        "is_verified": false,
        "attribute_note": null
    },
    "geo_region": {
        "attribute_name": "Geo Region",
        "attribute_value": "3",
        "is_editable": true,
        "is_verified": false,
        "attribute_note": null
    },
    "email": {
        "attribute_name": "Email",
        "attribute_value": "test@test.com",
        "is_editable": true,
        "is_verified": false,
        "attribute_note": null
    },
    "port_gold_status": {
        "attribute_name": "Porter Gold Status",
        "attribute_value": "NA",
        "is_editable": false,
        "is_verified": false,
        "attribute_note": null
    },
    "unconfirmed_email": {
        "attribute_name": "Unconfirmed Email",
        "attribute_value": null,
        "is_editable": true,
        "is_verified": false,
        "attribute_note": null
    },
    "gstin": {
        "attribute_name": "GSTIN",
        "attribute_value": "00000000000000",
        "is_editable": true,
        "is_verified": false,
        "attribute_note": null
    },
    "gst_reg_address": {
        "attribute_name": "GST Reg Address",
        "attribute_value": "abcdefghijklmnopqrstuvwxyz",
        "is_editable": true,
        "is_verified": false,
        "attribute_note": null
    },
    "customer_type": {
        "attribute_name": "Customer Type",
        "attribute_value": "Shop",
        "is_editable": true,
        "is_verified": false,
        "attribute_note": null
    },
    "temporarily_deactivated": {
        "attribute_name": "Temporarily deactivated",
        "attribute_value": "false",
        "is_editable": true,
        "is_verified": false,
        "attribute_note": null
    },
    "blacklist_reason": {
        "attribute_name": "Blacklist reason",
        "attribute_value": null,
        "is_editable": true,
        "is_verified": false,
        "attribute_note": null
    },
    "registration_status": {
        "attribute_name": "Registration Status",
        "attribute_value": "non_private_ltd",
        "is_editable": true,
        "is_verified": false,
        "attribute_note": null
    },
    "partload_customer": {
        "attribute_name": "PartLoad Customer",
        "attribute_value": "true",
        "is_editable": true,
        "is_verified": false,
        "attribute_note": null
    },
    "subscribed_for_promo_sms": {
        "attribute_name": "Subscribed for Promo SMS",
        "attribute_value": "true",
        "is_editable": true,
        "is_verified": false,
        "attribute_note": null
    },
    "is_business_customer": true
  };

var dummyUpdateCustomerResponse = {
    "summary": {
        "name": "Mohd.... Ayaz",
        "is_portergold_active": false,
        "mobile": "500000002",
        "address": null,
        "city": "Bangalore",
        "uuid": "f040bdc6-633d-47fc-8a1f-8bb9f69790f9",
        "referral": "You receive 20% off, up to Rs. 100, on your friend's first two trips."
    },
    "first_name": {
        "attribute_name": "First Name",
        "attribute_value": "Mohd....",
        "is_editable": true,
        "is_verified": false,
        "attribute_note": null
    },
    "last_name": {
        "attribute_name": "Last Name",
        "attribute_value": "Ayaz",
        "is_editable": true,
        "is_verified": false,
        "attribute_note": null
    },
    "caller_type": {
        "attribute_name": "Caller Type",
        "attribute_value": "PRIMARY",
        "is_editable": false,
        "is_verified": false,
        "attribute_note": null
    },
    "mobile": {
        "attribute_name": "Primary Number",
        "attribute_value": "500000002",
        "is_editable": false,
        "is_verified": true,
        "attribute_note": null
    },
    "secondary_mobile": {
        "attribute_name": "Secondary Number",
        "attribute_value": "7908031178",
        "is_editable": true,
        "is_verified": true,
        "attribute_note": null
    },
    "company_name": {
        "attribute_name": "Company  Name",
        "attribute_value": "",
        "is_editable": true,
        "is_verified": false,
        "attribute_note": null
    },
    "geo_region": {
        "attribute_name": "Geo Region",
        "attribute_value": "3",
        "is_editable": false,
        "is_verified": false,
        "attribute_note": null
    },
    "email": {
        "attribute_name": "Email",
        "attribute_value": "test@test.com",
        "is_editable": true,
        "is_verified": false,
        "attribute_note": null
    },
    "port_gold_status": {
        "attribute_name": "Porter Gold Status",
        "attribute_value": "NA",
        "is_editable": false,
        "is_verified": false,
        "attribute_note": null
    },
    "unconfirmed_email": {
        "attribute_name": "Unconfirmed Email",
        "attribute_value": null,
        "is_editable": true,
        "is_verified": false,
        "attribute_note": null
    },
    "customer_type": {
        "attribute_name": "Customer Type",
        "attribute_value": "Contractor",
        "is_editable": true,
        "is_verified": false,
        "attribute_note": null
    },
    "temporarily_deactivated": {
        "attribute_name": "Temporarily Deactivated",
        "attribute_value": "false",
        "is_editable": true,
        "is_verified": false,
        "attribute_note": null
    },
    "blacklist_reason": {
        "attribute_name": "Blacklist Reason",
        "attribute_value": null,
        "is_editable": false,
        "is_verified": false,
        "attribute_note": null
    },
    "registration_status": {
        "attribute_name": "Registration Status",
        "attribute_value": "non_private_ltd",
        "is_editable": true,
        "is_verified": false,
        "attribute_note": null
    },
    "partload_customer": {
        "attribute_name": "PartLoad Customer",
        "attribute_value": "false",
        "is_editable": true,
        "is_verified": false,
        "attribute_note": null
    },
    "subscribed_for_promo_sms": {
        "attribute_name": "SubscribedForPromoSms",
        "attribute_value": "true",
        "is_editable": true,
        "is_verified": false,
        "attribute_note": null
    },
    "gstin": {
        "attribute_name": "Gstin",
        "attribute_value": "",
        "is_editable": true,
        "is_verified": false,
        "attribute_note": null
    },
    "gst_reg_address": {
        "attribute_name": "GstRegAddress",
        "attribute_value": "",
        "is_editable": true,
        "is_verified": false,
        "attribute_note": null
    }
};

var dummyAddSecondaryNumberResponse = {
      "message": "OTP Sent",
      "request_id": 2534,
      "status": 200
    };

var dummyVerifyOtpResponse = {
      "message": "Number Successfully Verifed",
      "status": 200
    };

var dummySendPaymentResponse = {
    "message": "Link has been sent."
  };

var verifyEmailDummyResponse = {
    "recipient": "test@xyz.com"
  };

var dummyWalletResponse = {
    "is_updated": true,
    "wallet_balance": 123.05
  };

var dummyCashbackResponse = {
    "cashback_slab": "Silver",
    "cashback_offered": 50.0,
    "cashback_redeemed": 50.0,
    "cashback_balance": 0.0
  };

var dummyPorterGoldDetailsResponse = {
    status: "Orders remaining in current subscription: 7, Discount on order: 25% per order upto INR 75.0, Validity of subscription: 1st JANUARY 2024"
  };

var dummyCustomerConsentsRespone = {
    "consents": [
      {
        "message_type": "Transaction",
        "title": "Order and Support",
        "message": "message 1",
        "channels": [
          {
            "channel": "",
            "consent_config_id": 10,
            "title": "Call",
            "enabled": true,
            "alterable": true,
          },
          {
            "channel": "",
            "consent_config_id": 20,
            "title": "Message",
            "enabled": false,
            "alterable": true,
          },
          {
            "channel": "",
            "consent_config_id": 25,
            "title": "Push",
            "enabled": true,
            "alterable": false,
          },
        ],
      },
      {
        "message_type": "Promotional",
        "title": "Marketing",
        "message": "message 2",
        "channels": [
          {
            "channel": "",
            "consent_config_id": 7,
            "title": "Whatsapp",
            "enabled": false,
            "alterable": true,
          },
        ],
      },
    ]
  };

var dummyUpdateCustomerConsentsResponse = {
      status_code:200,
      status: "Successfull message"
    };

var dummyBlacklistingReasonsResponse = {
    "blacklisting_reasons": [
        {
            "id": 13,
            "description": "Dues above 400",
            "created_at": 1515392960448,
            "updated_at": 1515392960448,
            "show_for_manual_blacklisting": false,
            "blacklist_type": 0,
            "reason_enum": "BALANCE_VERY_LOW_PL"
        },
        {
            "id": 14,
            "description": "Uncleared dues",
            "created_at": 1652422482951,
            "updated_at": 1652422482951,
            "show_for_manual_blacklisting": false,
            "blacklist_type": 0,
            "reason_enum": "UNCLEARED_DUES"
        },
        {
            "id": 5,
            "description": "Exceeded order cancellations for today",
            "created_at": 1452251737758,
            "updated_at": 1452251737758,
            "show_for_manual_blacklisting": false,
            "blacklist_type": 1,
            "reason_enum": "EXCEEDED_ORDER_CANCELLATIONS"
        },
        {
            "id": 7,
            "description": "Customer underpayment for more than two orders",
            "created_at": 1452935157177,
            "updated_at": 1452935157177,
            "show_for_manual_blacklisting": false,
            "blacklist_type": 0,
            "reason_enum": "CUSTOMER_UNDERPAYMENT_MORE_THAN_TWO_ORDERS"
        },
        {
            "id": 8,
            "description": "Frequent cancellations",
            "created_at": 1455015050116,
            "updated_at": 1455015050116,
            "show_for_manual_blacklisting": false,
            "blacklist_type": 1,
            "reason_enum": "FREQUENT_ORDER_CANCELLATIONS"
        },
        {
            "id": 3,
            "description": "Fake Customer",
            "created_at": 1450435411431,
            "updated_at": 1450435411485,
            "show_for_manual_blacklisting": true,
            "blacklist_type": 1,
            "reason_enum": "FAKE_CUSTOMER"
        },
        {
            "id": 4,
            "description": "Customer Misbehaviour",
            "created_at": 1450435411433,
            "updated_at": 1450435411490,
            "show_for_manual_blacklisting": true,
            "blacklist_type": 1,
            "reason_enum": "CUSTOMER_MISBEHAVIOUR"
        },
        {
            "id": 9,
            "description": "Duplicate Account",
            "created_at": 1458281522112,
            "updated_at": 1458281522112,
            "show_for_manual_blacklisting": true,
            "blacklist_type": 1,
            "reason_enum": "DUPLICATE_ACCOUNT"
        },
        {
            "id": 1,
            "description": "Dues above 500",
            "created_at": 1450435411422,
            "updated_at": 1450435411422,
            "show_for_manual_blacklisting": false,
            "blacklist_type": 0,
            "reason_enum": null
        },
        {
            "id": 2,
            "description": "Dues above 100 - checked after 24 hours",
            "created_at": 1450435411428,
            "updated_at": 1450435411428,
            "show_for_manual_blacklisting": false,
            "blacklist_type": 0,
            "reason_enum": "BALANCE_LOW"
        },
        {
            "id": 10,
            "description": "Order Underpayment",
            "created_at": 1468404262129,
            "updated_at": 1468404262129,
            "show_for_manual_blacklisting": false,
            "blacklist_type": 0,
            "reason_enum": "ORDER_UNDERPAYMENT"
        },
        {
            "id": 11,
            "description": "Dues above 300",
            "created_at": 1468404262137,
            "updated_at": 1468404262137,
            "show_for_manual_blacklisting": false,
            "blacklist_type": 0,
            "reason_enum": null
        },
        {
            "id": 12,
            "description": "Dues above 200",
            "created_at": 1473172199118,
            "updated_at": 1473172199118,
            "show_for_manual_blacklisting": false,
            "blacklist_type": 0,
            "reason_enum": "BALANCE_VERY_LOW"
        },
        {
            "id": 48,
            "description": "Customer Abuse",
            "created_at": 1718813891563,
            "updated_at": 1718813891563,
            "show_for_manual_blacklisting": true,
            "blacklist_type": 1,
            "reason_enum": "CUSTOMER_ABUSE"
        },
        {
            "id": 15,
            "description": "Dues above 50 BDT",
            "created_at": null,
            "updated_at": 1710786664833,
            "show_for_manual_blacklisting": false,
            "blacklist_type": 0,
            "reason_enum": null
        },
        {
            "id": 6,
            "description": " Customer underpayment",
            "created_at": 1452935157170,
            "updated_at": 1487755703753,
            "show_for_manual_blacklisting": false,
            "blacklist_type": 1,
            "reason_enum": "CUSTOMER_UNDERPAYMENT"
        }
    ]
};

function fetchCustomer(_mobile, _country) {
  return new Promise((function (resolve, param) {
                  return resolve({
                              TAG: /* Success */0,
                              _0: dummyResponse
                            });
                })).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(CustomerRepoConfig.CustomerResponseConverter.execute, result);
                        });
            });
}

function updateCustomer(_data, _formData, _country) {
  return new Promise((function (resolve, param) {
                  return resolve({
                              TAG: /* Success */0,
                              _0: dummyUpdateCustomerResponse
                            });
                })).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(CustomerRepoConfig.CustomerResponseConverter.execute, result);
                        });
            });
}

function fetchTransationHistory(_uuid, _page_size, _last_date_timestamp, _country) {
  return new Promise((function (resolve, param) {
                  return resolve({
                              TAG: /* Success */0,
                              _0: dummyTransactionHistoryResponse
                            });
                })).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(CustomerRepoConfig.TransactionHistoryResponseConverter.execute, result);
                        });
            });
}

function fetchCustomerOrder(_uuid, _page_size, _last_date_timestamp, _country) {
  return new Promise((function (resolve, param) {
                  return resolve({
                              TAG: /* Success */0,
                              _0: dummyCustomerOrderResponse
                            });
                })).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(CustomerRepoConfig.CustomerOrderResponseConverter.execute, result);
                        });
            });
}

function addSecondaryNumber(_customer_id, _mobile, _caller_number, _country) {
  return new Promise((function (resolve, param) {
                  return resolve({
                              TAG: /* Success */0,
                              _0: dummyAddSecondaryNumberResponse
                            });
                })).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(CustomerRepoConfig.AddSecondaryNumberResponseConverter.execute, result);
                        });
            });
}

function verifyOtp(_customer_id, _otp, _request_id, _caller_number, _country) {
  return new Promise((function (resolve, param) {
                  return resolve({
                              TAG: /* Success */0,
                              _0: dummyVerifyOtpResponse
                            });
                })).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(CustomerRepoConfig.VerifyOtpResponseConverter.execute, result);
                        });
            });
}

function resendOTP(_customer_id, _request_id, _caller_number, _country) {
  return new Promise((function (resolve, param) {
                  return resolve({
                              TAG: /* Success */0,
                              _0: dummyAddSecondaryNumberResponse
                            });
                })).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(CustomerRepoConfig.ResendOTPResponseConverter.execute, result);
                        });
            });
}

function verifyEmail(_customer_id, _country) {
  return new Promise((function (resolve, param) {
                  return resolve({
                              TAG: /* Success */0,
                              _0: verifyEmailDummyResponse
                            });
                })).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(CustomerRepoConfig.VerifyEmailResponseConverter.execute, result);
                        });
            });
}

function sendPaymentLink(_customer_id, _amount, _country) {
  return new Promise((function (resolve, param) {
                  return resolve({
                              TAG: /* Success */0,
                              _0: dummySendPaymentResponse
                            });
                })).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(CustomerRepoConfig.SendPaymentRequestResponseConverter.execute, result);
                        });
            });
}

function updateWalletBalance(_customer_id, _wallet_balance, _update_amount, _updated_at, _country) {
  return new Promise((function (resolve, param) {
                  return resolve({
                              TAG: /* Success */0,
                              _0: dummyWalletResponse
                            });
                })).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(CustomerRepoConfig.UpdateWalletBalanceResponseConverter.execute, result);
                        });
            });
}

function fetchCashback(_customer_id, _country) {
  return new Promise((function (resolve, param) {
                  return resolve({
                              TAG: /* Success */0,
                              _0: dummyCashbackResponse
                            });
                })).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(CustomerRepoConfig.CashbackResponseConverter.execute, result);
                        });
            });
}

function fetchPorterGoldDetails(_customer_id, _country) {
  return new Promise((function (resolve, param) {
                  return resolve({
                              TAG: /* Success */0,
                              _0: dummyPorterGoldDetailsResponse
                            });
                })).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(CustomerRepoConfig.PorterGoldDetailsResponseConverter.execute, result);
                        });
            });
}

function fetchCustomerConsents(_uuid, _country) {
  return new Promise((function (resolve, param) {
                  return resolve({
                              TAG: /* Success */0,
                              _0: dummyCustomerConsentsRespone
                            });
                })).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(CustomerRepoConfig.CustomerConsentsResponseConverter.execute, result);
                        });
            });
}

function updateCustomerConsents(_payload, _country) {
  return new Promise((function (resolve, param) {
                  return resolve({
                              TAG: /* Success */0,
                              _0: dummyUpdateCustomerConsentsResponse
                            });
                })).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(CustomerRepoConfig.UpdateCustomerConsentsResponseConverter.execute, result);
                        });
            });
}

function fetchBlacklistingReasons(_country) {
  return new Promise((function (resolve, param) {
                  return resolve({
                              TAG: /* Success */0,
                              _0: dummyBlacklistingReasonsResponse
                            });
                })).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(CustomerRepoConfig.BlacklistingReasonsResponseConverter.execute, result);
                        });
            });
}

var CustomerRepo = {
  dummyCustomerOrderResponse: dummyCustomerOrderResponse,
  dummyTransactionHistoryResponse: dummyTransactionHistoryResponse,
  dummyResponse: dummyResponse,
  dummyUpdateCustomerResponse: dummyUpdateCustomerResponse,
  dummyAddSecondaryNumberResponse: dummyAddSecondaryNumberResponse,
  dummyVerifyOtpResponse: dummyVerifyOtpResponse,
  dummySendPaymentResponse: dummySendPaymentResponse,
  verifyEmailDummyResponse: verifyEmailDummyResponse,
  dummyWalletResponse: dummyWalletResponse,
  dummyCashbackResponse: dummyCashbackResponse,
  dummyPorterGoldDetailsResponse: dummyPorterGoldDetailsResponse,
  dummyCustomerConsentsRespone: dummyCustomerConsentsRespone,
  dummyUpdateCustomerConsentsResponse: dummyUpdateCustomerConsentsResponse,
  dummyBlacklistingReasonsResponse: dummyBlacklistingReasonsResponse,
  fetchCustomer: fetchCustomer,
  updateCustomer: updateCustomer,
  fetchTransationHistory: fetchTransationHistory,
  fetchCustomerOrder: fetchCustomerOrder,
  addSecondaryNumber: addSecondaryNumber,
  verifyOtp: verifyOtp,
  resendOTP: resendOTP,
  verifyEmail: verifyEmail,
  sendPaymentLink: sendPaymentLink,
  updateWalletBalance: updateWalletBalance,
  fetchCashback: fetchCashback,
  fetchPorterGoldDetails: fetchPorterGoldDetails,
  fetchCustomerConsents: fetchCustomerConsents,
  updateCustomerConsents: updateCustomerConsents,
  fetchBlacklistingReasons: fetchBlacklistingReasons
};

export {
  CustomerRepo ,
  
}
/* CustomerRepoConfig Not a pure module */
